// Lane module for the tunnel layout. Everything is metres in the y-up frame
// (origin bottom-left), so the UPPER lane is the one with the LARGER y and
// draws higher on screen. The viewport imports this to snap and project
// lane positions; the editor uses it to keep stations on their lane when the
// tunnel height changes.

export const LANE_FRACTION = { upper: 0.67, lower: 0.33 };

// Halfway between the two lanes. A y exactly here goes to the lower lane.
const LANE_MIDPOINT = (LANE_FRACTION.upper + LANE_FRACTION.lower) / 2;

/** Lane centre line in metres for a floor of the given height. */
export const laneYMeters = (lane, height) => LANE_FRACTION[lane] * height;

/** 'upper' | 'lower': the lane nearest to `y` (tie -> lower). */
export const laneForY = (y, height) =>
  y / height > LANE_MIDPOINT ? "upper" : "lower";

/** `y` snapped to the centre line of its nearest lane, in metres. */
export const snapToLaneY = (y, height) =>
  laneYMeters(laneForY(y, height), height);

/**
 * Re-seats every station on its current lane when the tunnel height changes.
 * Returns the input array untouched when nothing needs to move; otherwise a
 * new array of new station objects.
 */
export const adjustStationsForDimensionChange = (
  stations,
  oldHeight,
  newHeight,
) => {
  if (!oldHeight || !newHeight || oldHeight === newHeight) {
    return stations;
  }

  return stations.map((station) => {
    if (!station.position_meters) {
      return station;
    }
    const lane = laneForY(station.position_meters.y, oldHeight);
    return {
      ...station,
      position_meters: {
        x: station.position_meters.x,
        y: laneYMeters(lane, newHeight),
      },
    };
  });
};
